export default "__VITE_ASSET__qUjbzZXC__"